module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tw-select-none tw-absolute z-9999 tw-right-0 tw-top-0 tw-bottom-0 tw-w-[400px] tw-pointer-events-none",
    class: {
      'tw-hidden': !_vm.listNotification.length
    }
  }, [_c('NotificationScroll', {
    attrs: {
      "flagScroll": _vm.flagList,
      "isHeader": false
    },
    on: {
      "listenMouse": _vm.listenStopTimer
    }
  }, _vm._l((_vm.listNotification.slice().reverse()), function(notification) {
    return _c('NotificationItem', {
      key: notification.id,
      attrs: {
        "notification": notification,
        "canClose": true,
        "autoHide": true,
        "progressBar": true,
        "stopTimer": _vm.stopTimer
      },
      on: {
        "delete": _vm.deleteNotification
      }
    })
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47b7fd12"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared/components/notification/notification-list/notification-list.vue.html
// module id = EX3m
// module chunks = 2